import NotificationList from './NotificationList'

export {
    NotificationList
}
